module.exports = __webpack_public_path__ + "static/media/logo101.8adc04de.png";